import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { Skeleton } from '../../../components/Skeleton';
import styled from '../../../components/Theme';
import { FilterQuery, OrderBy } from '../../../consts';
import { useFilter } from '../../../utils/hooks';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UISelect from 'UIComponents/input/UISelect';
import I18n from 'I18n';
import { useDirectoryUsers } from '../directoryQueries';
const ResponsiveResultsBar = styled.div.withConfig({
  displayName: "SortResultsBar__ResponsiveResultsBar",
  componentId: "hgqpfy-0"
})(["display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;@media (max-width:", "){flex-direction:column;justify-content:center;align-items:flex-start;}"], props => props.theme.sizes.GRID_BREAKPOINT_SMALL);

const SortResultsBar = () => {
  const {
    totalUsers,
    usersLoading,
    pageNumber,
    resultsPerPage
  } = useDirectoryUsers();
  const {
    selectedItems: selectedOrder,
    handleReplace: handleReplaceOrder
  } = useFilter(FilterQuery.orderBy);
  const handleOrderChange = useCallback(e => {
    handleReplaceOrder(e.target.value.value);
  }, [handleReplaceOrder]);
  return /*#__PURE__*/_jsxs(ResponsiveResultsBar, {
    children: [!usersLoading ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connectDotCom.sort.numResults",
      options: {
        numStart: (pageNumber - 1) * resultsPerPage + 1,
        numEnd: Math.min(pageNumber * resultsPerPage, totalUsers),
        numTotal: totalUsers
      }
    }) : /*#__PURE__*/_jsx(Skeleton, {
      height: 24,
      width: 130
    }), /*#__PURE__*/_jsx(UIInlineLabel, {
      className: "m-right-0",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.sort.orderBy"
      }),
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "directory-sort",
        buttonUse: "transparent",
        value: selectedOrder.length ? selectedOrder[0] : OrderBy.Recent,
        onSelectedOptionChange: handleOrderChange,
        menuWidth: "auto",
        options: [{
          text: I18n.text('connectDotCom.sort.recentlyAwarded'),
          value: OrderBy.Recent
        }, {
          text: I18n.text('connectDotCom.sort.newest'),
          value: OrderBy.Newest
        }, {
          text: I18n.text('connectDotCom.sort.nameAZ'),
          value: OrderBy.NameAscending
        }, {
          text: I18n.text('connectDotCom.sort.nameZA'),
          value: OrderBy.NameDescending
        }]
      })
    })]
  });
};

export default SortResultsBar;